import React, { useEffect, useState } from 'react';
import { executeOrder, clearExecuteOrder } from './../../actions/zerodhaActions';
import { useDispatch, useSelector } from 'react-redux';
import { getForms } from '../../actions/formActions';
import SearchBoxWithListing from '../../components/Common/SearchBoxWithListing';
import { toast } from 'react-toastify';
import _ from "lodash"

const ZerodhaExecute = (props) => {
    const searchBoxKey = "ZERODHA_execute_search_form";
    const dispatch = useDispatch();
    const zerodhaState = useSelector((state) => state.zerodha);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { executeTrade = {} } = zerodhaState;
    const [fetchingList, setFetchingList] = useState(false);

    useEffect(() => {
        if (!_.isEmpty(executeTrade) && fetchingList) {
            const { status = {}, errors = [] } = executeTrade;
            const { success = false, } = status;
            if (success) {
                toast.success('Successfully Executed');
            } else {
                // Error messages are poped in ExternalAPIData itself
                // errors.map(errorObj => {
                //     const { message = 'Something went wrong' } = errorObj;
                //     toast.error(message);
                // })
            }
            setFetchingList(false);
            clearExecuteOrder();
        }
    }, [executeTrade])

    useEffect(() => {
        dispatch(getForms(searchBoxKey));
    }, []);

    const listApi = (payload) => {
        setFetchingList(true);
        return dispatch(executeOrder(payload));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={""}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={{}}
            // actionsHandling={actionsHandling}
            />
        </div>

    )
}

export default ZerodhaExecute;
